import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import EditIcon from "../../../Assets/OptionsModel/edit.svg";
import DeleteIcon from "../../../Assets/OptionsModel/Delete.svg";
import { setSelectedKebabItem, setListModal } from '../../../Features/couponsSlice';

function CouponDetailsKebab({ kebabOpen, boxRef }) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const dispatch = useDispatch();

    const [visible, setVisible] = useState(false);

    const coupon = useSelector((state) => state.coupons.coupon.coupon);

    useEffect(() => {
        if(kebabOpen) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [kebabOpen]);

    const handleEditCoupon = () => {
        let couponTypeRoute;

        switch (coupon.typeCoupon) {
            case 'PERCENTAGE_DISCOUNTS':
                couponTypeRoute = 'percentage-discounts';
                break;
            case 'FIXED_DISCOUNTS':
                couponTypeRoute = 'fixed-discounts';
                break;
            case 'BUYX_GETX':
                couponTypeRoute = 'buy-x-get-x';
                break;
            default:
                couponTypeRoute = '';
        }

        navigate(`${location.pathname.split('/').slice(0, -2).join('/')}/edit-coupon/${couponTypeRoute}/${params.couponId}`);
    }

    const handleDeleteCoupon = async (e) => {
        e.stopPropagation();
        dispatch(setSelectedKebabItem(coupon));
        dispatch(setListModal('delete-confirm'));
    }

    return (
        <div ref={boxRef} className={`${visible ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-all duration-150 ease-in-out bg-[#FFFFFF] absolute z-10 w-[200px] top-1 right-12 flex flex-col gap-0 shadow-[0px_0px_12px_0px_#0000003D] rounded-[5px] overflow-hidden`}>
            <button onClick={handleEditCoupon} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                <div className="size-[18px] flex items-center justify-center">
                    <img src={EditIcon} alt="" />
                </div>

                <p className='font-medium text-[14px] leading-5 text-[#121212]'>Edit</p>
            </button>

            {/* <button onClick={handleDeleteCoupon} className='w-full select-none flex items-center gap-[6px] px-2 py-[10px] rounded hover:bg-[#F5F5F5]'>
                <div className="size-[18px] flex items-center justify-center">
                    <img src={DeleteIcon} alt="" />
                </div>

                <p className='font-medium text-[14px] leading-5 text-[#121212]'>Delete</p>
            </button> */}
        </div>
    )
}

export default CouponDetailsKebab;
